export default "__VITE_ASSET__BU$sF_Mf__"